import api from "./api";
import {
  Retreat,
  FilterOptions,
  ApiResponse,
  PaginatedResponse,
  CreateRetreatRequest,
  TeacherItem,
  OrganizerItem,
  CenterItem,
  CreateTeacherRequest,
  CreateOrganizerRequest,
  CreateCenterRequest,
} from "../types";
import F1 from "../assets/home-images/f-1.png";
import F2 from "../assets/home-images/f-2.png";
import F3 from "../assets/home-images/f-3.png";
const mockRetreats: Retreat[] = [
  {
    id: "1",
    title:
      "Serenity Escape: A Transformative Wellness Retreat Experience in the Heart of Bali",
    description:
      "A transformative 7-day mindfulness retreat in the heart of Bali.",
    destination: {
      id: "1",
      name: "Ubud, Bali",
      country: "Indonesia",
      description:
        "A spiritual haven surrounded by rice terraces and ancient temples.",
      image: F1,
      coordinates: { lat: -8.5069, lng: 115.2625 },
    },
    retreatType: {
      id: "1",
      name: "Mindfulness",
      description: "Focus on meditation and inner peace",
      icon: "meditation",
    },
    price: 1200,
    duration: 7,
    maxParticipants: 20,
    currentParticipants: 15,
    images: [F1, F2, F3],
    features: [
      "Daily Meditation",
      "Yoga Classes",
      "Organic Meals",
      "Nature Walks",
    ],
    startDate: "2024-03-15",
    endDate: "2024-03-22",
    isActive: true,
    recentlyAdded: false,
    leavingSoon: false,
    hotOffer: true,
    startingTime: "4 Nights from",
    rating: 4.8,
    reviews: [],
  },
  {
    id: "2",
    title:
      "Serenity Escape: A Transformative Wellness Retreat Experience in the Heart of Bali",
    description:
      "Rejuvenate your mind and body with daily yoga and wellness practices.",
    destination: {
      id: "2",
      name: "Rishikesh, India",
      country: "India",
      description: "The yoga capital of the world, nestled in the Himalayas.",
      image: F1,
      coordinates: { lat: 30.0869, lng: 78.2676 },
    },
    retreatType: {
      id: "2",
      name: "Yoga",
      description: "Traditional yoga and wellness practices",
      icon: "yoga",
    },
    price: 800,
    duration: 10,
    maxParticipants: 25,
    currentParticipants: 18,
    images: [F1, F2],
    features: ["Hatha Yoga", "Pranayama", "Ayurvedic Meals", "Ganga Aarti"],
    startDate: "2024-04-01",
    endDate: "2024-04-11",
    isActive: true,
    recentlyAdded: false,
    leavingSoon: true,
    hotOffer: false,
    startingTime: "5 Nights from",
    rating: 4.9,
    reviews: [],
  },
  {
    id: "3",
    title:
      "Serenity Escape: A Transformative Wellness Retreat Experience in the Heart of Bali",
    description:
      "Rejuvenate your mind and body with daily yoga and wellness practices.",
    destination: {
      id: "2",
      name: "Rishikesh, India",
      country: "India",
      description: "The yoga capital of the world, nestled in the Himalayas.",
      image: F1,
      coordinates: { lat: 30.0869, lng: 78.2676 },
    },
    retreatType: {
      id: "2",
      name: "Yoga",
      description: "Traditional yoga and wellness practices",
      icon: "yoga",
    },
    price: 1400,
    duration: 10,
    maxParticipants: 25,
    currentParticipants: 18,
    images: [F1, F2],
    features: ["Hatha Yoga", "Pranayama", "Ayurvedic Meals", "Ganga Aarti"],
    startDate: "2024-04-01",
    endDate: "2024-04-11",
    isActive: true,
    recentlyAdded: false,
    leavingSoon: true,
    hotOffer: false,
    startingTime: "5 Nights from",
    rating: 4.9,
    reviews: [],
  },
];

export const retreatService = {
  async getRetreats(params?: {
    page?: number;
    limit?: number;
    filters?: FilterOptions;
  }): Promise<ApiResponse<PaginatedResponse<Retreat>>> {
    // Mock implementation - replace with actual API call when backend is ready
    return new Promise((resolve) => {
      setTimeout(() => {
        const page = params?.page || 1;
        const limit = params?.limit || 10;
        resolve({
          data: {
            data: mockRetreats,
            pagination: {
              page,
              limit,
              total: mockRetreats.length,
              totalPages: Math.ceil(mockRetreats.length / limit),
              pages: Math.ceil(mockRetreats.length / limit), // ✅ Added this line
            },
          },
          message: "Retreats fetched successfully",
          success: true,
        });
      }, 1000);
    });

    // Actual implementation (uncomment when backend is ready):
    // const response = await api.get('/retreats', { params });
    // return response.data;
  },

  async getFeaturedRetreats(): Promise<ApiResponse<Retreat[]>> {
    // Mock implementation
    // return new Promise((resolve) => {
    //   setTimeout(() => {
    //     resolve({
    //       data: mockRetreats.slice(0, 3),
    //       message: "Featured retreats fetched successfully",
    //       success: true,
    //     });
    //   }, 800);
    // });

    // Actual implementation (uncomment when backend is ready):
    const response = await api.get("/retreat/featured");
    return response?.data;
  },

  async searchRetreats(query: string): Promise<ApiResponse<Retreat[]>> {
    // Mock implementation
    return new Promise((resolve) => {
      setTimeout(() => {
        const results = mockRetreats.filter(
          (retreat) =>
            retreat.title.toLowerCase().includes(query.toLowerCase()) ||
            retreat.description.toLowerCase().includes(query.toLowerCase()) ||
            retreat.destination.name.toLowerCase().includes(query.toLowerCase())
        );
        resolve({
          data: results,
          message: "Search completed successfully",
          success: true,
        });
      }, 600);
    });

    // Actual implementation (uncomment when backend is ready):
    // const response = await api.get(`/retreats/search?q=${query}`);
    // return response.data;
  },

  async bookRetreat(
    retreatId: string,
    bookingData: any
  ): Promise<ApiResponse<any>> {
    const response = await api.post(`/retreats/${retreatId}/book`, bookingData);
    return response.data;
  },

  async createRetreat(
    retreatData: CreateRetreatRequest
  ): Promise<ApiResponse<any>> {
    const response = await api.post("/retreat", retreatData);
    return response.data;
  },

  async updateRetreat(
    retreatId: string,
    retreatData: Partial<CreateRetreatRequest>
  ): Promise<ApiResponse<any>> {
    const response = await api.put(`/retreat/${retreatId}`, retreatData);
    return response.data;
  },

  async saveDraft(
    retreatData: CreateRetreatRequest
  ): Promise<ApiResponse<any>> {
    const draftData = {
      ...retreatData,
      status: "draft",
    };
    const response = await api.post("/retreat", draftData);
    return response.data;
  },

  async getAllRetreats(
    page: number = 1,
    limit: number = 10,
    status?: "published" | "draft" | "pending"
  ): Promise<ApiResponse<any>> {
    const params: any = { page, limit };
    if (status) {
      params.status = status;
    }

    const response = await api.get("/retreat", { params });
    return response.data;
  },
  async getPublicRetreats(
    page: number = 1,
    limit: number = 10,
    status?: "published" | "draft" | "pending",
    searchParams?: {
      search?: string;
      location?: string;
      startDate?: string;
      endDate?: string;
    }
  ): Promise<ApiResponse<any>> {
    const params: any = { page, limit };
    
    // Add search parameters if provided
    if (searchParams?.search) {
      params.search = searchParams.search;
    }
    if (searchParams?.location) {
      params.location = searchParams.location;
    }
    if (searchParams?.startDate) {
      params.startDate = searchParams.startDate;
    }
    if (searchParams?.endDate) {
      params.endDate = searchParams.endDate;
    }

    const response = await api.get("/retreat/published", { params });
    return response.data;
  },
  async getRetreatByIdApi(retreatId: string): Promise<ApiResponse<any>> {
    const response = await api.get(`/retreat/${retreatId}`);
    return response.data;
  },

  async updateRetreatApi(
    retreatId: string,
    retreatData: any
  ): Promise<ApiResponse<any>> {
    const response = await api.put(`/retreat/${retreatId}`, retreatData);
    return response.data;
  },

  async deleteRetreat(retreatId: string): Promise<ApiResponse<any>> {
    const response = await api.delete(`/retreat/${retreatId}`);
    return response.data;
  },

  // Related entities services
  async getTeachers(
    page = 1,
    limit = 10
  ): Promise<ApiResponse<PaginatedResponse<TeacherItem>>> {
    const response = await api.get("/teacher", {
      params: {
        page,
        limit,
      },
    });
    return response.data;
  },

  async createTeacher(
    teacherData: CreateTeacherRequest
  ): Promise<ApiResponse<TeacherItem>> {
    const response = await api.post("/teacher", teacherData);
    return response.data;
  },

  async getOrganizers(
    page = 1,
    limit = 10
  ): Promise<ApiResponse<PaginatedResponse<OrganizerItem>>> {
    const response = await api.get("/organizer", {
      params: {
        page,
        limit,
      },
    });
    return response.data;
  },

  async createOrganizer(
    organizerData: CreateOrganizerRequest
  ): Promise<ApiResponse<OrganizerItem>> {
    const response = await api.post("/organizer", organizerData);
    return response.data;
  },

  async getCenters(
    page = 1,
    limit = 10
  ): Promise<ApiResponse<PaginatedResponse<CenterItem>>> {
    const response = await api.get("/center", {
      params: {
        page,
        limit,
      },
    });
    return response.data;
  },

  async createCenter(
    centerData: CreateCenterRequest
  ): Promise<ApiResponse<CenterItem>> {
    const response = await api.post("/center", centerData);
    return response.data;
  },

  async getAccommodations(
    params: { page?: number; limit?: number } = {}
  ): Promise<ApiResponse<any>> {
    const { page = 1, limit = 10 } = params;
    const response = await api.get(
      `/accommodation?page=${page}&limit=${limit}`
    );
    return response.data;
  },

  async createAccommodation(accommodationData: any): Promise<ApiResponse<any>> {
    const response = await api.post("/accommodation", accommodationData);
    return response.data;
  },
};
